/* eslint-disable jsx-a11y/no-static-element-interactions, react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getDisplayName } from '../../lib/messageHelper';
import { trackLink, trackPage } from '../../lib/analytics-helper';
import contentHelper from '../../lib/contentHelper';
import i18n from '../../lib/reacti18n';
import UrlResources from '../../home/constants/UrlResources';
import { getAlertRedirectFaq } from '../../lib/TrackersHelper';
import { QuestionAlt } from '../svg-sets';
import { setInnerContent } from '../../lib/globalHelper';

const redirectClass = 'refund-status-link';
const alertRedirectUrl = `/smarthelp/article/${getAlertRedirectFaq()}`;
const labels = {
  refundAlertInfo: i18n.message('refundHelp/refundHelp.transactionList.alert.info'),
};

class RefundAlert extends Component {
  // Get alert translated text
  static getAlertInfo() {
    return contentHelper(labels.refundAlertInfo, { user: getDisplayName(), link: alertRedirectUrl });
  }

  componentDidMount() {
    // On component mount fire impression event to track refund alert.
    trackPage({ id: this.getRefundsFPTIReferenceId() });
  }

  // On click handler on clicking refunds alert.
  onClickHandler(e) {
    e.preventDefault();
    if (e.target.className === redirectClass) {
      trackLink({ id: this.getRefundsFPTIReferenceId(), link: 'refund-alert|link|click' });
      window.open(alertRedirectUrl, '_self');
    }
  }

  // Get corresponding FPTI based on the current path
  getRefundsFPTIReferenceId() {
    const { pathName } = this.props;
    if (pathName === 'contactUs') {
      return 'refundAlertContactUs';
    }

    if (pathName.indexOf(UrlResources.SEARCH) > 0) {
      return 'refundAlertSearch';
    }

    return '';
  }

  render() {
    return (
      <div className="tracker-alert-container">
        <div className="tracker-alert-container__alert-icon">
          {QuestionAlt()}
        </div>
        <div className="tracker-alert-container_alert-content">
          <span
            onClick={(e) => this.onClickHandler(e)}
            dangerouslySetInnerHTML={setInnerContent(RefundAlert.getAlertInfo())}
          />
        </div>
      </div>
    );
  }
}

// Refund Alert Props Types.
RefundAlert.propTypes = {
  pathName: PropTypes.string.isRequired,
};

export default RefundAlert;
